export default "__VITE_PUBLIC_ASSET__fb53b6f1__"